import { Box } from '@mui/material';
import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import SlotListDragHandle from './slot-list-drag-handle';
import SlotListLockIndicator from './slot-list-lock-indicator';
import { SLOT_LIST_DRAG_HANDLE_SIZE_PX } from './slot-list-layout';

type SlotListLeftLeadingProps = {
  enabled: boolean;
  showDragHandle: boolean;
  showLockIndicator: boolean;
  isDragging: boolean;
  dragDisabled: boolean;
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap | undefined;
};

export default function SlotListLeftLeading({
  enabled,
  showDragHandle,
  showLockIndicator,
  isDragging,
  dragDisabled,
  attributes,
  listeners,
}: SlotListLeftLeadingProps) {
  if (!enabled) {
    return null;
  }

  if (showDragHandle) {
    return (
      <SlotListDragHandle
        isDragging={isDragging}
        interactionDisabled={dragDisabled}
        attributes={attributes}
        listeners={listeners}
      />
    );
  }

  if (showLockIndicator) {
    return <SlotListLockIndicator />;
  }

  return (
    <Box
      sx={{
        width: SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        minWidth: SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        flexShrink: 0,
      }}
    />
  );
}
